export type HTMLVideoElementEvents = undefined | 'load' | 'ended' | 'error' | 'playing' | 'loadeddata' | 'loadstart' | 'complete' | 'canplaythrough' | 'seeked' | 'seeking' | 'canplay' | 'timeupdate'

export type VideoStats = {
      playing: boolean
      ended: boolean
      currentTime: number
      length: number
      canPlayThrough: boolean
      canPlay: boolean
      seeking: boolean
      lastEvent: HTMLVideoElementEvents
      muted: boolean
}

export class Seek {
      element: HTMLElement
      cleanup: AbortController

      onendCallback: Function | undefined
      onmoveCallback: Function | undefined

      cycleEnd: AbortController | undefined

      position = {
            x: 0,
            y: 0,
            start_x: 0,
            start_y: 0,
      }

      tracking: boolean = false

      constructor({ element, onmove, onend }: { element: HTMLElement; onmove?: Function; onend?: Function }) {
            this.element = element
            this.onendCallback = onend
            this.onmoveCallback = onmove
            this.cleanup = new AbortController()
            return this
      }

      destroy() {
            if (this.cycleEnd) this.cycleEnd.abort()
            this.cleanup.abort()
      }

      init() {
            this.element.addEventListener('mousedown', (e) => this.onstart(e), { signal: this.cleanup.signal, capture: false })
            this.element.addEventListener('touchstart', (e) => this.onstart(e), { signal: this.cleanup.signal, capture: false })
      }

      onstart(ev: MouseEvent | TouchEvent) {

            this.cycleEnd = new AbortController()
            ev.stopPropagation()
            ev.preventDefault()
            if (ev instanceof MouseEvent) {
                  console.log('start')
                  this.position.x = ev.clientX
                  this.position.y = ev.clientY

                  this.position.start_x = this.position.x
                  this.position.start_y = this.position.y

                  document.addEventListener('mouseup', (e) => this.onend(e), { signal: this.cycleEnd.signal, capture: true})
                  document.addEventListener('mousemove', (e) => this.onmove(e), { signal: this.cycleEnd.signal, capture: true })
            }

            if (ev instanceof TouchEvent) {
                  if (ev.touches.length > 1) return
                  console.log('start')
                  this.position.x = ev.touches[0].clientX
                  this.position.y = ev.touches[0].clientY

                  this.position.start_x = this.position.x
                  this.position.start_y = this.position.x

                  document.addEventListener('touchend', (e) => this.onend(e), { signal: this.cycleEnd.signal, capture: true })
                  document.addEventListener('touchmove', (e) => this.onmove(e), { signal: this.cycleEnd.signal, capture: true })
            }

            this.tracking = true
      }

      onmove(ev: MouseEvent | TouchEvent) {
            if (!this.tracking) return
            ev.stopPropagation()
            ev.preventDefault()

            let tempDeltaX = 0,
                  tempDeltaY = 0,
                  deltaX = 0,
                  deltaY = 0
            if (ev instanceof MouseEvent) {
                  tempDeltaX = ev.clientX - this.position.x
                  tempDeltaY = ev.clientY - this.position.y

                  this.position.x = ev.clientX
                  this.position.y = ev.clientY

                  deltaX = this.position.x - this.position.start_x
                  deltaY = this.position.y - this.position.start_y
            }

            if (ev instanceof TouchEvent) {
                  if (ev.touches.length > 1) return

                  tempDeltaX = ev.touches[0].clientX - this.position.x
                  tempDeltaY = ev.touches[0].clientY - this.position.y

                  this.position.x = ev.touches[0].clientX
                  this.position.y = ev.touches[0].clientY

                  deltaX = this.position.x - this.position.start_x
                  deltaY = this.position.y - this.position.start_y
            }

            const parent = this.element.parentElement
            if (!parent) return

            const width = parent.getBoundingClientRect().width
            const tempPercX = (tempDeltaX / width) * 100

            if (this.onmoveCallback)
                  this.onmoveCallback({
                        ...this.position,
                        tempDeltaX,
                        tempDeltaY,
                        deltaX,
                        deltaY,
                        tempPercX,
                  })
      }

      onend(ev: MouseEvent | TouchEvent) {
            
            ev.stopPropagation()
            ev.stopImmediatePropagation()
            ev.preventDefault()
            console.log('end')
            this.tracking = false
            if (this.cycleEnd) this.cycleEnd.abort()

            let tempDeltaX = 0,
                  tempDeltaY = 0,
                  deltaX = 0,
                  deltaY = 0
            if (ev instanceof MouseEvent) {
                  tempDeltaX = ev.clientX - this.position.x
                  tempDeltaY = ev.clientY - this.position.y

                  this.position.x = ev.clientX
                  this.position.y = ev.clientY

                  deltaX = this.position.x - this.position.start_x
                  deltaY = this.position.y - this.position.start_y
            }

            if (ev instanceof TouchEvent && ev.touches.length > 0) {
                  if (ev.touches.length > 1) return

                  tempDeltaX = ev.touches[0].clientX - this.position.x
                  tempDeltaY = ev.touches[0].clientY - this.position.y

                  this.position.x = ev.touches[0].clientX
                  this.position.y = ev.touches[0].clientY

                  deltaX = this.position.x - this.position.start_x
                  deltaY = this.position.y - this.position.start_y
            }

            const parent = this.element.parentElement
            if (!parent) return

            const width = parent.getBoundingClientRect().width
            const tempPercX = (tempDeltaX / width) * 100

            if (this.onendCallback)
                  this.onendCallback({
                        ...this.position,
                        tempDeltaX,
                        tempDeltaY,
                        deltaX,
                        deltaY,
                        tempPercX,
                  })
      }
}
